import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, FlexSpan } from "../../../ui";
import { DemandBlock } from "./DemandBlock";
import { HouseholdsBlock } from "./HouseholdsBlock";
import { BusinessBlock } from "./BusinessBlock";
import { TransportBlock } from "./TransportBlock";
export const PointDescription = ({ data }) => {
    return (_jsx(Flex, { column: true, height: "100%", children: _jsxs(FlexSpan, { flexGrow: 1, m: "1.25rem 0", overflow: "auto", p: "0 4px", children: [_jsx(DemandBlock, { data: data }), _jsx(HouseholdsBlock, { data: data }), _jsx(BusinessBlock, { data: data }), _jsx(TransportBlock, { data: data })] }) }));
};
